module.exports = __webpack_public_path__ + "img/4.f1bd8431.jpg";